import { render } from "./PopupAdPurchaseView.vue?vue&type=template&id=4a81462a&scoped=true"
import script from "./PopupAdPurchaseView.vue?vue&type=script&lang=js"
export * from "./PopupAdPurchaseView.vue?vue&type=script&lang=js"

import "./PopupAdPurchaseView.vue?vue&type=style&index=0&id=4a81462a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a81462a"]])

export default __exports__